module.exports = __webpack_public_path__ + "images/emoji/rooster.9260e55cfb33e4fe00bf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rooster.png
// module id = s5DB
// module chunks = 24